export const INITIAL_STATE = {
  AUTH: null,
};
